import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import { MOBILE_ROUTE_NAMES } from '../../../../../../constants/tasks';

import './index.scss';

const MutateTipPionToScreen = ({ name, ...props }) => {
  const [field, fieldMeta] = useField(name);

  return (
    <select
      {...props}
      {...field}
      className={classNames(
        'mutate-tip-pion-to-screen',
        { 'mutate-tip-pion-to-screen-error': fieldMeta.error },
        props.className,
      )}
    >
      <option value="">- Select -</option>
      {Object.values(MOBILE_ROUTE_NAMES).map((MOBILE_ROUTE_NAME) => (
        <option key={MOBILE_ROUTE_NAME} value={MOBILE_ROUTE_NAME}>
          {MOBILE_ROUTE_NAME}
        </option>
      ))}
    </select>
  );
};

export default MutateTipPionToScreen;
